<template>
  <SocialsViewWrapper>
    <OverviewParams />
    <LoaderFullPage v-if="store.loading" />
    <OverviewDatas v-else />
  </SocialsViewWrapper>
</template>

<script setup>
import SocialsViewWrapper from "@follaw-fr/components/social-media/templates/SocialsViewWrapper.vue";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import OverviewParams from "@follaw-fr/components/social-media/overview/organisms/OverviewParams.vue";
import OverviewDatas from "@follaw-fr/components/social-media/overview/organisms/OverviewDatas.vue";
import { useSocialMediaStatsStore } from "@follaw-fr/stores/social-media/statistics";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import { PermissionLevel } from "@/follaw-fr/constants/enums/permission-level.enum";

const store = useSocialMediaStatsStore();
const userSettingsStore = useUserSettingsStore();

if (userSettingsStore.hasPermission(PermissionLevel.SOCIETAL)) {
  store.fetchOverview();
}
</script>
